import React from 'react'
import { useLogoContext } from '../../logo/LogoContext'
import { IMAGE_PATH } from '../../../../data/constant';
import { useTranslation } from 'react-i18next';
import { PRIMARY_COLOR } from '../../../../data/color';

export default function InvoiceHeader(props) {
     const { title,number } = props;
     const { t } = useTranslation();
     const { logo } = useLogoContext();   
     return (
          <div className='row pb-2' style={{ borderBottom: `1px solid ${PRIMARY_COLOR}` }}>
               <div className='col-4 d-flex align-items-center'>
                    {logo && logo.logo !== undefined && (
                         <img src={`${IMAGE_PATH}/logo/${logo.logo}`} className="img-fluid" alt="logo" style={{ width: "50%" }} />
                    )}
               </div>
               <div className='col-4 text-center d-flex align-items-center justify-content-center'>
                    <h4>{t(title)}</h4>
               </div>
               <div className='col-4 text-right d-flex align-items-center justify-content-end  '>
                    <h4># {t(number)}</h4>
               </div>
          </div>
     )
}
